import { Component, OnInit, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { InformesService } from 'app/services/informes.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material';
import { RellamadaComponent } from 'app/modals/rellamada/rellamada.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.scss']
})
export class InformesComponent implements OnInit,AfterViewInit {
  public form:FormGroup;
  public epidemia:string;
  public informe:string;
  public servicios:any;
  public dtOptions:any;
  public dtTrigger:Subject<void>;
  @ViewChild(DataTableDirective, {static: false}) tabla: DataTableDirective;
  constructor(private _informes:InformesService, private _renderer:Renderer2,private _dialog:MatDialog) {
    this.servicios = [];

    this.dtTrigger = new Subject();
  }
  ngAfterViewInit(): void {
    this._renderer.listen('document','click',(e)=>{
      if(e.target.hasAttribute('llamadas-csc')){
        this.abrirModalLlamadas(e.target.getAttribute('llamadas-csc'),e.target);
        return;
      }
      if(e.target.hasAttribute('positivo-csc')){
        this.abrirModalPositivo(e.target.getAttribute('positivo-csc'),e.target);
        return;
      }
      if(e.target.hasAttribute('fiebre-csc')){
        this.modalFiebre(e.target.getAttribute('fiebre-csc'),e.target);
        return;
      }
      if(e.target.hasAttribute('tos-csc')){
        this.modalTosEspectorada(e.target.getAttribute('tos-csc'),e.target);
        return;
      }
      if(e.target.hasAttribute('respiracion-csc')){
        this.modalDificultadRespiratoria(e.target.getAttribute('respiracion-csc'),e.target);
        return;
      }
      if(e.target.hasAttribute('rinorrea-csc')){
        this.modalRinorrea(e.target.getAttribute('rinorrea-csc'),e.target);
        return;
      }
      if(e.target.hasAttribute('obs-csc')){
        this.modalObs(e.target.getAttribute('obs-csc'),e.target);
        return;
      }
      if(e.target.hasAttribute('atencion-csc')){
        this.modalRequiereAtencion(e.target.getAttribute('atencion-csc'),e.target);
        return;
      }
      if(e.target.hasAttribute('seguimiento-csc')){
        this.modalRequiereSeguimiento(e.target.getAttribute('seguimiento-csc'),e.target);
        return;
      }
    })
  }

  ngOnInit() {
    this.form = this.createForm();
  }
  searchCovid(){
    let body = {...this.form.value};
    this.dtOptions = {
      responsive: {
        details: {
            type: 'column',
            target: -1
        }
      },
      autoWidth: false,
      order: [1, 'desc'],
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        },
        select: {
          rows: {
            _: "%d Filas seleccionadas",
            0: "Da clic en una fila para seleccionarla",
            1: "1 Fila seleccionada"
          }
        }
      },
      columns: [
        {
          title:'',
          orderable:false
        },
        {
          title:'consecutivo',
          data:'consecutivo',
        },
        {
          title:'Atención telefonica',
          data:'fecha',
        },
        {
          title:'Fecha de seguimiento',
          data:'CovidFechaSeguimiento',
        },
        {
          title:'telefonos',
          data:'numeros',
        },
        {
          title:'nombres',
          data:'nombre',
        },
        {
          title:'sospecha',
          render: (data, type, row, meta) => {
            let cadena:string;
            if(data == 1){
              return `<a >Sospechoso</a>`
            }
            return `<a>No sospechoso</a>`
          }
        },
        {
          title:'Tipo de covid sospechado',
          data:'CovidTipoSospecha'
        },
        {
          title:'Positivo?',
          render: (data, type, row, meta) => {
            
            if(data == 1){
              return `<a positivo-csc="${row.consecutivo}">Si</a>`
            }
            return `<a positivo-csc="${row.consecutivo}">No</a>`
          },
        },
        {
          title:'fiebre',
          render: (data, type, row, meta) => {
            let cadena:string;
              return `<a fiebre-csc="${row.consecutivo}">${data}</a>`
          }
        },
        {
          title:'tos con espectoración',
          render: (data, type, row, meta) => {
            let cadena:string;
            if(data == 1){
              return `<a tos-csc="${row.consecutivo}">Con tos espectorada</a>`
            }
            return `<a tos-csc="${row.consecutivo}">Sin tos espectorada</a>`
          }
        },
        {
          title:'Dificultad respiratoria (ahogo)',
          render: (data, type, row, meta) => {
            let cadena:string;
            if(data == 1){
              return `<a respiracion-csc="${row.consecutivo}">Con dificultad respiratoria</a>`
            }
            return `<a respiracion-csc="${row.consecutivo}">Sin dificultad respiratoria</a>`
          }
        },
        {
          title:'Congestión con rinorrea / Color',
          render: (data, type, row, meta) => {
            return `<a rinorrea-csc="${row.consecutivo}">${data}</a>`    
          }
        },
        {
          title:'EVOLUCION DEL PACIENTE',
          render:(data, type, row, meta)=>{
            return `<a obs-csc="${row.consecutivo}">${data}</a>`
          }
        },
        {
          title:'REQUIERE ATENCION',
          render: (data, type, row, meta) => {
            if(row.CovidAtencion == 1){
              return `<a atencion-csc="${row.consecutivo}">Requiere atención</a>`
            }
            return `<a atencion-csc="${row.consecutivo}">No requiere atención</a>`
          }
        },
        {
          title:'REQUIERE SEGUIMIENTO',
          render: (data, type, row, meta) => {
            if(data == 1){
              return `<a seguimiento-csc="${row.consecutivo}">Requiere seguimiento</a>`
            }
            return `<a seguimiento-csc="${row.consecutivo}">No requiere seguimiento</a>`
          }
        },
        {
          title:'Notificación Calidad',
          render: (data, type, row, meta) => {
            if(data == 1){
              return `<span class="notificada${row.consecutivo}">Notificado</span>`
            }
            return `<span class="notificada${row.consecutivo}">Sin notificar</span>`
          }
        },
        {
          title:'Seguimiento hecho por',
          render:(data, type, row, meta)=>{
            return `<span class="seguido${row.consecutivo}">${data}</span>`
          }
        },
        {
          title:'Llamadas',
          render:(data, type, row, meta)=>{
            return `<a llamadas-csc=${row.consecutivo}> ${data}</a>`;
          }
        },
        {
          title:'Antecedentes',
          data:'antecedentes'
        },
        {
          title:'Notas de la consulta',
          data:'notasConsulta'
        },
        {
          title:'Notas del operador',
          data:'notasOperador'
        },
        {
          title:'Tipo Servicio',
          data:'reqtps'
        },
        {
          title:'Signos y sintomas',
          data:'reqsig'
        },
        {
          className: 'control',
          orderable: false,
          targets:   -1
        }
      ]
    }
    body.fechaFinal =  moment(body.fechaFinal).format("YYYY-MM-DD");
    body.fechaInicio = moment(body.fechaInicio).format("YYYY-MM-DD");
    this._informes.informeCovid(body).subscribe(succ=>{
      this.servicios = succ;
      if(this.tabla.dtInstance !== undefined){
        this.renderer();
        return;
      }
      this.dtTrigger.next();
    })
  }

  createForm(){
    return new FormGroup({
      fechaInicio:new FormControl(moment('2020-03-16')),
      fechaFinal:new FormControl(moment()),
      sospecha:new FormControl(''),
      tipoSospecha:new FormControl(''),
      positivo:new  FormControl(''),
      seguimiento: new  FormControl(''),
      tiempoMonitoreo:new FormControl(''),
      conLlamadas: new FormControl(''),
    });
  }

  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  abrirModalFiebre(REQCSC){
  }
  
  abrirModalLlamadas(csc,target){
    let rellamadas = this._dialog.open(RellamadaComponent,{
      width:'50vw',
        data: {csc}
    });
    rellamadas.afterClosed().subscribe(rellamadas=>{
      //Target hace referencia al elemento donde se dio click
      target.innerText = `${rellamadas == undefined ? '0':rellamadas}`;
    })
  }

  async abrirModalPositivo(csc,target){
    let {value,dismiss} = await Swal.fire({
      title:'Desea cambiar el estado de confirmación del pasciente?',
      text:'A que estado desea cambiar la confirmación del paciente?',
      input:'select',
      inputOptions:{
        0:'No',
        1:'Si'
      },
      showCancelButton:true,
    });
    if(!dismiss){
      this._informes.actualizarTitPositivo(csc,value).subscribe(async actu=>{
        //Target hace referencia al elemento donde se dio click
        target.innerText = (value == 0)?'No':'Si';
      })
      //Target hace referencia al elemento donde se dio click
      target.innerText = (value == 0)?'No':'Si';
    }
    
  }

  notificar(csc){
    this._informes.notificar(csc).subscribe(succ=>{
      let span = <HTMLSpanElement>document.querySelectorAll(`.notificada${csc}`)[1];
      span.innerText = 'Notificado';
    })
  }

  async modalFiebre(csc,target){
    const {value,dismiss} = await Swal.fire({
      title: 'Multiple inputs',
      html:
        `
        <label for="swal-input1">Fiebre?</label>
        <select id="swal-input1" class="swal2-input">
        <option value="1">Con fiebre</option>
        <option value="0">Sin fiebre</option>
        </select>
        <label for="swal-input2">Temperatura</label>
        <input id="swal-input2" class="swal2-input">`,
      focusConfirm: false,
      preConfirm: () => {
        let input1 = <HTMLInputElement>document.getElementById('swal-input1')
        let input2 = <HTMLInputElement>document.getElementById('swal-input2')

        return [
          input1.value,
          input2.value
        ]
      }
    })
    if(!dismiss){
      let [fiebre,temperatura] = value;
      let usuario = JSON.parse(localStorage.getItem("usuario")).nombre

      this._informes.updateFiebre(csc,fiebre,temperatura).subscribe(succ=>{
        this.exito();
        //Target hace referencia al elemento donde se dio click
        target.innerText = (fiebre == 1)? `Si, ${temperatura}°`:'No';
        let span:NodeListOf<HTMLSpanElement> = document.querySelectorAll(`.seguido${csc}`);
        console.log(span);
        if(span[1].innerText === ""){
          span[1].innerText = usuario;
        }
      });
    }
  }

  public async exito(){
    await Swal.fire({
      type:'success',
      text:'Se actualizó satisfactoriamente',
      timer:1000,
      showConfirmButton:false,
      showCancelButton:false
    })
  }

  public async modalTosEspectorada(csc,target){
    let {value,dismiss} = await Swal.fire({
      title:'Tos Espectorada',
      text:'El paciente presenta tos con espectoración?',
      input:'select',
      inputOptions:{
        0:'No presenta',
        1:'Si presenta'
      }
    })

    if(!dismiss){
        this._informes.updateTos(csc,value).subscribe(()=>{
          this.exito();
          //Target hace referencia al elemento donde se dio click
          target.innerText = (value == 1)? 'Con tos espectorada' : 'Sin tos espectorada';
        });
    }
  }
  public async modalDificultadRespiratoria(csc,target){
    let {value,dismiss} = await Swal.fire({
      title:'Dificultad Respiratoria',
      text:'El paciente presenta dificultad respiratoria (ahogo)?',
      input:'select',
      inputOptions:{
        0:'No presenta',
        1:'Si presenta'
      }
    })

    if(!dismiss){
        this._informes.updateDificultadRespiratoria(csc,value).subscribe(()=>{
          this.exito();
          //Target hace referencia al elemento donde se dio click
          target.innerText = (value == 1)? 'Con dificultad respiratoria' : 'Sin  dificultad respiratoria';
        });
    }
  }

  async modalRinorrea(csc,target){
    const {value,dismiss} = await Swal.fire({
      title: 'Rinorrea',
      text:'El paciente presenta rinorrea',
      html:
        `
        <label for="swal-input1">Fiebre?</label>
        <select id="swal-input1r" class="swal2-input">
        <option value="1">Presenta</option>
        <option value="0">No presenta</option>
        </select>
        <label for="swal-input2">Color</label>
        <input id="swal-input2r" class="swal2-input">`,
      focusConfirm: false,
      preConfirm: () => {
        let input1 = <HTMLInputElement>document.getElementById('swal-input1r')
        let input2 = <HTMLInputElement>document.getElementById('swal-input2r')

        return [
          input1.value,
          input2.value
        ]
      }
    })
    if(!dismiss){
      let [rinorrea,color] = value;
      this._informes.updateFiebre(csc,rinorrea,color).subscribe(succ=>{
        this.exito();
        //Target hace referencia al elemento donde se dio click
        target.innerText = (rinorrea == 1)? `Si, ${color  }`:'No';
      });
    }
  }
  async modalObs(csc,target){
    let {value,dismiss} = await Swal.fire({
      title:'Dificultad Respiratoria',
      text:'El paciente presenta dificultad respiratoria (ahogo)?',
      input:'textarea',
      //Target hace referencia al elemento donde se dio click
      inputValue:target.innerText.replace(/^#/,"")
    });
    if(!dismiss){
      this._informes.updateObs(csc,value).subscribe(()=>{
        this.exito();
        //Target hace referencia al elemento donde se dio click
        target.innerText = value;
      });
    }
  }

  public async modalRequiereAtencion(csc,target){
    let {value,dismiss} = await Swal.fire({
      title:'Atención',
      text:'El paciente requiere atención?',
      input:'select',
      inputOptions:{
        1:'Requerida',
        0:'No requerida'
      }
    })

    if(!dismiss){
        this._informes.updateAtencion(csc,value).subscribe(()=>{
          this.exito();
          //Target hace referencia al elemento donde se dio click
          target.innerText = (value == 1)? 'Requiere atención' : 'No requiere atención';
        });
    }
  }
  public async modalRequiereSeguimiento(csc,target){
    let {value,dismiss} = await Swal.fire({
      title:'Seguimiento',
      text:'El paciente requiere seguimiento?',
      input:'select',
      inputOptions:{
        1:'Requerido',
        0:'No requerido'
      }
    })

    if(!dismiss){
        this._informes.updateSeguimiento(csc,value).subscribe(()=>{
          this.exito();
          //Target hace referencia al elemento donde se dio click
          target.innerText = (value == 1)? 'Requiere seguimiento' : 'No requiere seguimiento';
        });
    }
  }
}
